import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import eaApplications from './modules/eaApplications'
import settings from './modules/settings'
import documentUpload from './modules/documentUpload'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    eaApplications,
    settings,
    documentUpload
  }
})
store.dispatch('setStore') // Passes store instance on to any other helpers that need it
export default store
